<template>
  <div class="bg_gray">
    <Header navTitle="购物车" navPath=""></Header>
    <van-swipe-cell v-for="(item, index) in cartItems" :key="index">
      <div class="course_item_wrap">
        <van-checkbox v-model="item.is_checked" shape="square" :disabled="!item.is_valid" @change="selectRowChanged(cartItems)"></van-checkbox>
        <div :class="{'course_item_common': true, 'pointer': true, 'disabled': item.is_valid == false}">
          <div class="cover" @click="goCurDetail(scope.row.cur_uuid)">
            <img :src="item.cur_cover" />
            <span class="hot" v-if="item.cur_label && item.cur_label != 'null'">{{item.cur_label}}</span>
            <span class="tag" v-if="item.cur_type">{{ item.cur_type }}</span>
            <div class="layer" v-if="item.is_valid == false">已失效</div>
          </div>
          <div class="content">
            <h4 @click="goCurDetail(item.cur_uuid)" class="text_ellipsis">{{ item.cur_name }}</h4>
            <div class="info">
              <span :style="item.is_valid == false ? 'color:#999;' : ''">¥ {{ item.price }}</span>课时：{{ item.chapter_desc }}
            </div>
          </div>
        </div>
      </div>
      <template #right>
        <van-button square text="移除" type="danger" style="height:100%;" @click="deleteCartGoods([item.uuid])" />
      </template>
    </van-swipe-cell>
    <van-empty description="暂无内容哦~" v-if="cartItems.length === 0" />
    <div class="tip" v-else>已选中 {{ selectedRows.length }} 个商品</div>
    <!-- 总价 -->
    <div class="sheet_fixed_bottom_common">
      金额：<span><span>¥</span>{{selectedAmount}}</span>
      <van-button type="danger" round @click="buySelectedGoods" :disabled="selectedRows.length == 0">立即购买</van-button>
    </div>

    <!-- 用户信息 -->
    <van-popup v-model:show="userModal.user_message" position="right" :style="{ width: '100%', height: '100%' }">
      <van-nav-bar z-index="10" left-arrow title="完善个人信息" @click-left="cancel_message"></van-nav-bar>
        <van-form ref="infoForm">
          <van-cell-group>
            <van-cell title-style="font-weight:bold" title="&#160;&#160;&#160;&#160;&#160;&#160;请如实填写您的个人信息，以保证您的正常学习！" />
            <van-field
              v-model="userModal.userList.realname"
              name="work_place"
              :formatter="formatter1"
              label="姓名"
              placeholder="请输入姓名"
              :rules="rules.realname"
            />
            <van-field name="job" label="职业">
              <template #input>
                <van-radio-group v-model="userModal.userList.job" direction="horizontal">
                  <van-radio name="office">职员</van-radio>
                  <van-radio name="student">学生</van-radio>
                  <van-radio name="teacher">教师</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="userModal.userList.work_place"
              name="work_place"
              :formatter="formatter1"
              label="单位/学校"
              placeholder="请输入学校/单位"
              :rules="rules.work_place"
            />
            <van-field
              v-model="userModal.userList.job_name"
              name="job_name"
              :formatter="formatter1"
              label="岗位/专业"
              placeholder="请输入岗位/专业"
              :rules="rules.job_name"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit" @click="submitForm('infoForm')">
              保存
            </van-button>
          </div>
        </van-form>
    </van-popup>


  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import { listCartItems, fmtCartItemInfo,  deleteCartItems, CART_GOODS_TYPE_CUR, CART_GOODS_TYPE_VIP} from 'api/settlement/cart/user'
  import { prepareOrder } from 'api/settlement/order/user'
  import { checkMessage } from 'api/promoter/selectPromo'
  import { updateUserInfo } from 'api/user/user/user'
  import { GetUserState } from 'api/user/auth/login'
  export default {
    components: {
      Header
    },
    data() {

      let checkInput = (value, rule) => {
        return new Promise(resolve => {
            if (value.length > 50){
                resolve('字符长度限制在1到50个字符以内')
            }else {
                resolve(true)
            }
        })
      }

      let checkInputLengthRule = (value, rule) => {
        console.log(value)
        if(value.length >= 50){
          return '字符长度限制在1到50个字符以内';
        }
        let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
        if(iconRule2.test(value)){
          return "不能包含表情符号"
        }
        return true;

      }

      return {
        cartItems: [],
        cartItemsLoading: true,
        cartItemsEmptyMsg: ' ',
        selectedRows: [],
        selectedAmount: 0,
        invalidGoodsCount: 0,
        userModal:{
          user_id:'',
          user_message:false,
          userList:{
            realname:'',
            job:'office',
            work_place:'',
            job_name:''
          }
        },
        rules: {
          job_name: [
            { required: true, message: '请输入岗位/专业', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          work_place: [
            { required: true, message: '请输入学校/单位', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          realname: [
            { required: true, message: '请输入姓名', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ]
        }
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.loadCartItems()
      this.getuserId()
    },
    unmounted() {
      this.$emit('update:isShowHeader', true);
    },
    methods: {
      getuserId(){
        GetUserState().then((res) => {
          this.userModal.user_id = res.id
        })
      },
      formatter1(value) {
        // 过滤空格
        return value.replace(/^ +| +$/g, '');
      },
      loadCartItems(){

        this.cartItemsLoading = true;

        this.$emit('update:isShowOverlay', true);
        listCartItems().then(result => {

          if (result.succeed) {

            this.cartItems = [];
            let validCartItems = [];
            let invalidCartItems = [];

            result.data.forEach(item => {
              let filled_item = fmtCartItemInfo(item);

              if (item.is_valid){
                  validCartItems.push(filled_item)
              } else {
                  invalidCartItems.push(filled_item)
              }

            });

            validCartItems.forEach(item=>{ item.is_checked = false; this.cartItems.push(item) });
            invalidCartItems.forEach(item=>{ item.is_checked = false; this.cartItems.push(item) });

            console.log(this.cartItems);

            this.invalidGoodsCount = invalidCartItems.length;

            if (this.cartItems.length === 0){
                this.cartItemsEmptyMsg = '暂无数据';
            }

            this.$emit('update:cartItemCount', result.data.length);

          } else {

            switch (result.error_code) {
              case -9999 : {
                this.$emit('update:loginVisible', true);
              }
                break;
              default: {

                this.$dialog.alert({
                  title: '提示',
                  message: `${result.error_msg}`,
                });

              }
                break;
            }

          }

          this.cartItemsLoading = false;

          this.$emit('update:isShowOverlay', false);

        }).catch(err => {

          this.$dialog.alert({
            title: '提示',
            message: `${err}`,
          });

          this.$emit('update:isShowOverlay', false);

        });

      },
      selectRowChanged(val) {
        this.selectedRows = val.filter(item=>{
          return item.is_checked === true
        })
        // this.selectedRows = val;

        let amount = 0;

        this.selectedRows.forEach(item=>{
            amount += item.price;
        });

        this.selectedAmount = parseFloat(amount.toFixed(2));

      },
      deleteCartGoods(goods_uuid_arr, remove_invalid=false){

        const that = this;

        let confirm_msg = remove_invalid ? '您确定要移除失效的商品吗？' : '您确定要删除该购物车商品吗?';

        this.$dialog.confirm({
          title: '提示',
          message: confirm_msg,
        }).then(() => {

          deleteCartItems(goods_uuid_arr).then(result=>{

            if (result.succeed) {

                that.loadCartItems();

            } else {

              this.$dialog.alert({
                title: '提示',
                message: `${result.error_msg}`,
              });
            }

          }).catch(err => {

            this.$dialog.alert({
              title: '提示',
              message: `${err}`,
            });
          });

        });

      },
      clearInvalidGoods(){

        let invalid_cart_uuid_list = [];
        this.cartItems.forEach(item => {

          if (item.is_valid == false) {
            invalid_cart_uuid_list.push(item.uuid)
          }

        });

        if (invalid_cart_uuid_list.length > 0) {
            this.deleteCartGoods(invalid_cart_uuid_list, true);
        } else {

          this.$dialog.alert({
            title: '提示',
            message: '购物车中不存在失效的商品',
          });
        }

      },
      cartItemCheckBoxEnableNotify(row, index){
        return row.is_valid;
      },
      buySelectedGoods(){
        checkMessage().then((res) => {
          if(res.data == 0) {
            if (this.selectedRows.length > 0) {
              let prepare_data = [];
              this.selectedRows.forEach(item => {
                prepare_data.push({
                  type: item.goods_type_text,
                  res_uuid: item.goods_uuid
                })
              });

              console.log(prepare_data);

              const that = this;
              prepareOrder(prepare_data).then(result => {

                if (result.succeed) {
                  that.goPath(`/mobile/order/confirm/${result.confirm_key}`);
                } else {
                  this.$dialog.alert({
                    title: '提示',
                    message: result.error_msg,
                  })
                }

              }).catch(err => {
                this.$dialog.alert({
                  title: '提示',
                  message: err,
                })
              });


            } else {
              this.$dialog.alert({
                title: '提示',
                message: '您尚未选择需要购买的商品',
              })
            }
          }else{
            this.userModal.userList.realname = res.user.realname
            this.userModal.userList.job_name = res.user.job_name
            if (res.user.job != null){
              this.userModal.userList.job = res.user.job
            }else{
              this.userModal.userList.job = 'office'
            }
            this.userModal.userList.work_place = res.user.work_place
            this.userModal.user_message = true
          }
        })
      },
      goPath(path) {
        this.$router.push(path);
      },
      goCurDetail(cur_uuid){
        const cur_detail_page = this.$router.resolve({name: 'CourseDetail', params: {uuid: cur_uuid}});
        window.open(cur_detail_page.href, '_blank');
      },

      updateUserInfoMethod(data) {
        updateUserInfo(this.userModal.user_id, data)
          .then((res) => {
            this.loading = false;
            if (res.result === 0) {
              this.$router.go(0);
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
          }).catch((err) => {
          this.loading = false;
          this.$alert('服务异常，请稍后再试', '提示', {
                confirmButtonText: '确定',
          });
        })
      },
      cancel_message() {
        this.userModal.user_message = false
      },
      submitForm(formName) {
        this.$refs[formName].validate().then(() => {
            this.updateUserInfoMethod({"job": this.userModal.userList.job, "job_name": this.userModal.userList.job_name, "work_place": this.userModal.userList.work_place, "realname": this.userModal.userList.realname});
        });
      },

    }
  }
</script>

<style lang="scss" scoped>
  .course_item_wrap {
    display:flex;
    background:#fff;
    margin-top:15px;
    .van-checkbox {
      margin-left:10px;
    }
    .course_item_common {
      flex:1;
      min-width: 0;
      &.disabled {
        .content {
          > h4, .info {
            color:#999;
          }
        }
      }
    }
  }
  .tip {
    padding:20px 10px 30px 10px;
  }
  .sheet_fixed_bottom_common {
    display:flex;
    align-items: center;
    justify-content: flex-end;
    > span {
      margin-left:10px;
      margin-right:15px;
      font-size:32px;
      color:#f51c21;
      font-family: 'font-540';
      > span {
        font-size:18px;
        margin-right:5px;
      }
    }
  }
</style>
